import type { ValueTypeEntry } from "../index";
import { TextEditor, type TextValue } from "./text-editor";

/**
 * Built-in `text` field type. The renderer returns a bare ReactNode (the
 * string) so consumers can wrap it in their own truncation / hover
 * primitives — keeping this entry free of `@quovy/ui` deps. Editor is a
 * minimal controlled `<input>` that commits on Enter, cancels on Escape,
 * and commits on blur.
 */
export const textType: ValueTypeEntry<TextValue> = {
  name: "text",
  wrap: "truncate",
  format(value) {
    return value ?? "";
  },
  render({ value }) {
    return value ?? "";
  },
  display({ value }) {
    // Narrow `unknown` to `string | null` — anything else is rendered as
    // empty. Truncation is the consumer's responsibility (the cell layer
    // wraps the returned node in `TruncatedValue`).
    return typeof value === "string" ? value : null;
  },
  edit({ value, onCommit, onCancel }) {
    return <TextEditor value={value} onCommit={onCommit} onCancel={onCancel} />;
  },
};
